import axios from "axios";

//const API_ROUTE = 'http://api.labsoupllc.com';
//const API_ROUTE = "http://localhost:5000";
const API_ROUTE = "https://api.bigblueenergydrinks.com";
//const API_ROUTE = 'http://192.168.1.150:81';

axios.interceptors.response.use(undefined, function (err) {
  if (
    err.response.status === 401 ||
    err.response.data.message === "401 Unauthorized"
  ) {
    window.location = "/login";
  }
  return Promise.reject(err);
});

export function get_image_url(id) {
  return `${API_ROUTE}/images/${id}`;
}
export async function get(route) {
  const token = localStorage.getItem("token");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const response = await axios.get(`${API_ROUTE}${route}`);
  return response.data;
}
export async function put(route, data) {
  const token = localStorage.getItem("token");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const response = await axios.put(`${API_ROUTE}${route}`, data);
  return response.data;
}
export async function postMultipart(route, data) {
  const token = localStorage.getItem("token");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const response = await axios.post(`${API_ROUTE}${route}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}
export async function post(route, data) {
  const token = localStorage.getItem("token");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const response = await axios.post(`${API_ROUTE}${route}`, data);
  return response.data;
}
export async function get_feedback_for(id) {
  const response = await get(`/feedback/${id}`);
  return response.data;
}
export async function get_codes() {
  const response = await get(`/discount_codes`);
  return response.data;
}
export async function get_drinks() {
  const response = await get(`/items`);
  return response.data;
}
export async function get_stats() {
  const response = await get("/stats");
  return response.data;
}
export async function get_feedback() {
  const response = await get(`/feedback`);
  return response.data;
}
export async function get_orders(all) {
  const response = await get(`/orders${all ? "" : "/new"}`);
  return response.data;
}
export async function get_groups() {
  const response = await get(`/item_groups`);
  return response.data;
}
export async function complete_order(order_id) {
  const response = await get(`/orders/ship/${order_id}`);
  return response.data;
}
export async function token_test() {
  const response = await get("/token");
  if (response.status === 200) {
    return true;
  }
  return false;
}
export async function login(lvm) {
  const response = await axios.post(`${API_ROUTE}/admin/login`, lvm);
  if (response.status === 200) {
    localStorage.setItem("token", response.data.bearer);
    localStorage.setItem("first_name", response.data.first_name);
    localStorage.setItem("last_name", response.data.last_name);
    return true;
  }
  return false;
}
